import React, { useRef, useState } from "react";
import copy from "copy-to-clipboard";
import Button from "@material-ui/core/Button";
import firebase from "./../firebase";

export default function Card(props) {
  const inputEl = useRef(null);
  const [copied, setCopied] = useState("Copy");
  const [changeInput, setChangeInput] = useState(props.code);

  const handleCopy = param => {
    copy(inputEl.current.value);
    if (props.link) {
      setCopied(`Copied Link`);
    } else {
      setCopied(`Copied '${props.code}'`);
    }
    setTimeout(() => {
      setCopied("Copy");
    }, 3000);
  };

  // const writeUserData = (userId, name, email, imageUrl) => {
  //   firebase
  //     .database()
  //     .ref("users/" + userId)
  //     .set({
  //       codes: codes.category,
  //       email: "test",
  //       lyft: "code"
  //     });
  //   console.log(database);
  // };
  // Wire up change ability to handle code change and usestate

  const handleCodeChange = e => {
    console.log(e.target.value);
    setChangeInput(e.target.value);
    console.log(changeInput);
    // writeUserData()
  };
  return (
    <div className="">
      {/* <MyContext.Consumer>{value => <p>{value}</p>}</MyContext.Consumer> */}
      <div
        className={`cardWrapper ${
          props.darkBackground
            ? "backgroundForDarkLogo"
            : "backgroundForLightLogo"
        }`}
      >
        <img
          className={`logoWrapper ${props.darkLogo ? "dark" : "light"}`}
          src={props.img}
          alt="blank"
        />
        <div className="selectionWrapper">
          <input
            type="text"
            value={changeInput}
            ref={inputEl}
            onChange={handleCodeChange}
          />
          <Button
            className="copyButton"
            color="secondary"
            variant="contained"
            onClick={handleCopy}
          >
            {copied}
          </Button>
          <div className="googlePlayAndAppStore">
            <a href={props.googlePlayLink}>
              <img src={props.googlePlay} alt="" />
            </a>
            <a href={props.appStoreLink}>
              <img src={props.appStore} alt="" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
